"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Tile = _interopRequireDefault(require("./Tile.js"));

var _TileState = _interopRequireDefault(require("./TileState.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/VectorTile
 */


var VectorTile =
/** @class */
function (_super) {
  __extends(VectorTile, _super);
  /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Data source url.
   * @param {import("./format/Feature.js").default} format Feature format.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [opt_options] Tile options.
   */


  function VectorTile(tileCoord, state, src, format, tileLoadFunction, opt_options) {
    var _this = _super.call(this, tileCoord, state, opt_options) || this;
    /**
     * Extent of this tile; set by the source.
     * @type {import("./extent.js").Extent}
     */


    _this.extent = null;
    /**
     * @private
     * @type {import("./format/Feature.js").default}
     */

    _this.format_ = format;
    /**
     * @private
     * @type {Array<import("./Feature.js").default>}
     */

    _this.features_ = null;
    /**
     * @private
     * @type {import("./featureloader.js").FeatureLoader}
     */

    _this.loader_;
    /**
     * Feature projection of this tile; set by the source.
     * @type {import("./proj/Projection.js").default}
     */

    _this.projection = null;
    /**
     * Resolution of this tile; set by the source.
     * @type {number}
     */

    _this.resolution;
    /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */

    _this.tileLoadFunction_ = tileLoadFunction;
    /**
     * @private
     * @type {string}
     */

    _this.url_ = src;
    _this.key = src;
    return _this;
  }
  /**
   * Get the feature format assigned for reading this tile's features.
   * @return {import("./format/Feature.js").default} Feature format.
   * @api
   */


  VectorTile.prototype.getFormat = function () {
    return this.format_;
  };
  /**
   * Get the features for this tile. Geometries will be in the view projection.
   * @return {Array<import("./Feature.js").FeatureLike>} Features.
   * @api
   */


  VectorTile.prototype.getFeatures = function () {
    return this.features_;
  };
  /**
   * Load not yet loaded URI.
   */


  VectorTile.prototype.load = function () {
    if (this.state == _TileState["default"].IDLE) {
      this.setState(_TileState["default"].LOADING);
      this.tileLoadFunction_(this, this.url_);

      if (this.loader_) {
        this.loader_(this.extent, this.resolution, this.projection);
      }
    }
  };
  /**
   * Handler for successful tile load.
   * @param {Array<import("./Feature.js").default>} features The loaded features.
   * @param {import("./proj/Projection.js").default} dataProjection Data projection.
   */


  VectorTile.prototype.onLoad = function (features, dataProjection) {
    this.setFeatures(features);
  };
  /**
   * Handler for tile load errors.
   */


  VectorTile.prototype.onError = function () {
    this.setState(_TileState["default"].ERROR);
  };
  /**
   * Function for use in an {@link module:ol/source/VectorTile~VectorTile}'s `tileLoadFunction`.
   * Sets the features for the tile.
   * @param {Array<import("./Feature.js").default>} features Features.
   * @api
   */


  VectorTile.prototype.setFeatures = function (features) {
    this.features_ = features;
    this.setState(_TileState["default"].LOADED);
  };
  /**
   * Set the feature loader for reading this tile's features.
   * @param {import("./featureloader.js").FeatureLoader} loader Feature loader.
   * @api
   */


  VectorTile.prototype.setLoader = function (loader) {
    this.loader_ = loader;
  };

  return VectorTile;
}(_Tile["default"]);

var _default = VectorTile;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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